import { TextField } from "@origin-digital/ods-core";
import * as React from "react";
import { IFormProps } from "../FormAccordionContainer";
import { useField } from "formik";

export interface IGeneralTextField extends IFormProps {
  field: {
    name: string;
    value: string;
    onChange: (e: React.ChangeEvent<any>) => void;
    onBlur: (e: React.FocusEvent<any>) => void;
  };
  label: string;
  id: string;
  type?: string;
  startIcon?: React.ReactNode;
  helperText: string;
  maxLength?: number;
  endIcon?: React.ReactNode;
  disabled?: boolean;
  domProps?: React.HTMLAttributes<HTMLInputElement>;
}

const GeneralTextField = (props: IGeneralTextField) => {
  const {
    field,
    label,
    id,
    type,
    startIcon,
    helperText,
    maxLength,
    endIcon,
    disabled,
    domProps,
  } = props;
  const [, { error }] = useField(field.name);

  return (
    <TextField
      {...field}
      id={id}
      variant="outlined"
      label={label}
      error={!!error}
      helperText={error || helperText}
      hideHelperTextSpace
      type={type}
      startIcon={startIcon}
      maxLength={maxLength}
      endIcon={endIcon}
      disabled={disabled}
      domProps={domProps}
    />
  );
};

export default GeneralTextField;
